export default "__VITE_ASSET__D2w7uaW8__"